import { shallowEqual } from '@mnd-frontend/utils';

// the components prop might not be constant while the components are constant
// shallow compare the components inside the object
const compareComponentsProps = (
  { components: prevComponents, ...prev }: any,
  { components: propComponents, ...props }: any,
) => shallowEqual(prev, props) && shallowEqual(prevComponents, propComponents);

export default compareComponentsProps;
